const { default: CommonServices } = require("./common/common");

class FavoritesManagementService extends CommonServices {
  constructor() {
    super("/users/favorites");
  }
}

const favoritesManagementService = new FavoritesManagementService();
export default favoritesManagementService;
